"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "biella": {
    "dc06e2c2": [{
      "hkey": "ffcd7e26",
      "slug": "brazzetto-oremo-vandorno",
      "name": "Brazzetto-Oremo-Vandorno",
      "primary": true,
      "skipSearch": false
    }],
    "barazzetto-vandorno": [{
      "hkey": "ffcd7e26",
      "slug": "brazzetto-oremo-vandorno",
      "name": "Brazzetto-Oremo-Vandorno",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d8560123": [{
      "hkey": "c97bb574",
      "slug": "chiavazza",
      "name": "Chiavazza",
      "primary": true,
      "skipSearch": false
    }],
    "chiavazza-vaglio": [{
      "hkey": "c97bb574",
      "slug": "chiavazza",
      "name": "Chiavazza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "6a0d98d0": [{
      "hkey": "b1a6887e",
      "slug": "biella",
      "name": "Biella",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "b1a6887e",
      "slug": "biella",
      "name": "Biella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fef2ce01": [{
      "hkey": "9b3703ef",
      "slug": "riva",
      "name": "Riva",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "9b3703ef",
      "slug": "riva",
      "name": "Riva",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;